export default {
  name: 'VirtualDeviceDriverList'
};